module.exports = __webpack_public_path__ + "static/img/tsl2.1a37bbb7.jpg";